/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import httpService from '@/core/http/http.service';
import serverContextStore from '@/shared/content/server-context.store';

export class STOREClient {

    getOrderReceiptByOrderNumber(orderNumber: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfOrderReceiptModel> {
        let apiPathAndParams = '/api/store-context/order-receipt/{orderNumber}';
        if (orderNumber === undefined || orderNumber === null)
            throw new Error('The parameter "orderNumber" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{orderNumber}', encodeURIComponent('' + orderNumber));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfOrderReceiptModel>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/order-receipt/{orderNumber}-' + cancellationContextKey : undefined);
    }
    printOrderReceiptByOrderNumber(byOrderNumberRequest: PrintOrderReceiptByOrderNumberRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/store-context/order-receipt/print';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, byOrderNumberRequest, messageId);
    }
    printGiftCertificatesByOrderNumber(byOrderNumberRequest: PrintGiftCertificatesByOrderNumberRequest, messageId?: string): Promise<ClientResponseOfPrintGiftCertificatesResult> {
        let apiPathAndParams = '/api/store-context/order-receipt/print/gift-certificates';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPrintGiftCertificatesResult>(apiUrl, byOrderNumberRequest, messageId);
    }
    getCustomerAddressSuggestions(searchTerm: string | undefined, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfCustomerAddressSuggestionModelOf> {
        let apiPathAndParams = '/api/store-context/customer/address/suggestions?';
        if (searchTerm === null)
            throw new Error('The parameter "searchTerm" cannot be null.');
        else if (searchTerm !== undefined)
            apiPathAndParams += 'searchTerm=' + encodeURIComponent('' + searchTerm) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfCustomerAddressSuggestionModelOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/customer/address/suggestions-' + cancellationContextKey : undefined);
    }
    getCustomerAddressSuggestionByEmail(email: string | undefined, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfCustomerAddressSuggestionModel> {
        let apiPathAndParams = '/api/store-context/customer/email?';
        if (email === null)
            throw new Error('The parameter "email" cannot be null.');
        else if (email !== undefined)
            apiPathAndParams += 'email=' + encodeURIComponent('' + email) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfCustomerAddressSuggestionModel>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/customer/email-' + cancellationContextKey : undefined);
    }
    printCustomerOfferById(request: PrintCustomerOfferByIdRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/store-context/customer-offer/print';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, request, messageId);
    }
    createCustomerOfferConsentRequest(request: CreateCustomerOfferConsentRequest, messageId?: string): Promise<ClientResponseOfCreateConsentResponse> {
        let apiPathAndParams = '/api/store-context/customer-offer/create-customer-offer-consent-request';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfCreateConsentResponse>(apiUrl, request, messageId);
    }
    acceptCustomerOfferConsentRequest(request: AcceptCustomerOfferConsentRequest, messageId?: string): Promise<ClientResponse> {
        let apiPathAndParams = '/api/store-context/customer-offer/accept-customer-offer-consent-request';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponse>(apiUrl, request, messageId);
    }
    plusCurrency(request: number[], messageId?: string): Promise<ClientResponseOfBoliaMoney> {
        let apiPathAndParams = '/api/store-context/calculator/plus-currency';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBoliaMoney>(apiUrl, request, messageId);
    }
    getBasketForCheckOut(basketId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfBasketCheckoutModel>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/check-out-' + cancellationContextKey : undefined);
    }
    addInvoiceAddress(basketId: string, invoiceAddressRequest: AddInvoiceAddressToBasketRequest, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/invoice-address';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, invoiceAddressRequest, messageId);
    }
    toggleCustomerMyBoliaSubscription(basketId: string, subscribe: boolean, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/toggle-mybolia-subscription';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, subscribe, messageId);
    }
    setDeliveryAddress(basketId: string, deliveryAddress: BasketDeliveryAddress, deliveryId: number, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/delivery/{deliveryId}/delivery-address';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, deliveryAddress, messageId);
    }
    setDeliveryTime(basketId: string, deliveryId: number, deliveryTimeRequest: SetDeliveryTimeRequest, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/delivery/{deliveryId}/delivery-time';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, deliveryTimeRequest, messageId);
    }
    setCommentForHomeDelivery(basketId: string, deliveryId: number, setCommentRequest: SetCustomerDeliveryCommentRequest, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/delivery/{deliveryId}/set-comment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, setCommentRequest, messageId);
    }
    addDeliveryOption(basketId: string, deliveryId: number, itemId: string, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/delivery/{deliveryId}/delivery-option/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    removeDeliveryOption(basketId: string, deliveryId: number, itemId: string, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/delivery/{deliveryId}/delivery-option/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    changeClickAndCollectStoreFromCheckOut(basketId: string, storeId: string, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/change-click-and-collect-store/{storeId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (storeId === undefined || storeId === null)
            throw new Error('The parameter "storeId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{storeId}', encodeURIComponent('' + storeId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    setTermsAndConditions(basketId: string, termId: number, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/terms/{termId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (termId === undefined || termId === null)
            throw new Error('The parameter "termId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{termId}', encodeURIComponent('' + termId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    splitDelivery(basketId: string, deliveryId: number, itemIds: number[], messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/delivery/{deliveryId}/split';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, itemIds, messageId);
    }
    removeSplitDelivery(basketId: string, deliveryId: number, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/delivery/{deliveryId}/split';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    removeSplitDeliveries(basketId: string, deliveryId: number, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/delivery/{deliveryId}/remove-split';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    checkOutPos(basketId: string, checkOutRequest: CheckOutPosRequest, messageId?: string): Promise<ClientResponseOfCheckOutPosPaymentResult> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/pos';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfCheckOutPosPaymentResult>(apiUrl, checkOutRequest, messageId);
    }
    checkOutOnlinePayment(basketId: string, checkOutRequest: CheckOutOnlinePaymentRequest, messageId?: string): Promise<ClientResponseOfCheckOutPaymentResult> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/online-payment';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfCheckOutPaymentResult>(apiUrl, checkOutRequest, messageId);
    }
    getNearestParcelShopsForDelivery(basketId: string, deliveryId: number, amount: number | null | undefined, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfParcelShopModelOf> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/{deliveryId}/parcel-shops?';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        if (amount !== undefined && amount !== null)
            apiPathAndParams += 'amount=' + encodeURIComponent('' + amount) + '&';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfParcelShopModelOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/check-out/{deliveryId}/parcel-shops-' + cancellationContextKey : undefined);
    }
    getParcelShopsForZipCode(postalCode: string, basketId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfParcelShopModelOf> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/parcel-shops/{postalCode}';
        if (postalCode === undefined || postalCode === null)
            throw new Error('The parameter "postalCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{postalCode}', encodeURIComponent('' + postalCode));
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfParcelShopModelOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/check-out/parcel-shops/{postalCode}-' + cancellationContextKey : undefined);
    }
    setPickAndPackToParcelShopDelivery(basketId: string, parcelShop: ParcelShopModel, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/SetPickAndPackToParcelShopDelivery';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, parcelShop, messageId);
    }
    setPickAndPackToHomeDelivery(basketId: string, messageId?: string): Promise<ClientResponseOfBasketCheckoutModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/SetPickAndPackToHomeDelivery';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketCheckoutModel>(apiUrl, messageId);
    }
    submitBankTransferPayment(basketId: string, checkOutRequest: CheckOutBankTransferPaymentRequest, messageId?: string): Promise<ClientResponseOfFinalizeBankTransferPaymentResult> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/check-out/payment/bank-transfer';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfFinalizeBankTransferPaymentResult>(apiUrl, checkOutRequest, messageId);
    }
    getBasket(basketId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfBasketModel>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}-' + cancellationContextKey : undefined);
    }
    deleteBasket(basketId: string, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    addRegularItem(basketId: string, request: AddBasketItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/regular';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addPickAndPackItem(basketId: string, request: AddBasketItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/pick-and-pack';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addClickAndCollectItem(basketId: string, request: AddClickAndCollectBasketItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/click-and-collect';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addInstantItem(basketId: string, request: AddInstantItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/instant';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addOutletItem(basketId: string, request: AddOutletItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/outlet';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addCustomItem(basketId: string, request: AddCustomItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/custom';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addGiftCardItem(basketId: string, request: AddGiftCardItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/gift-card';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addModuleSofaItem(basketId: string, request: AddModuleSofaRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/module-sofa';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    updateModuleSofaItem(basketId: string, moduleSofaReferenceId: string, request: AddModuleSofaRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/module-sofa/{moduleSofaReferenceId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (moduleSofaReferenceId === undefined || moduleSofaReferenceId === null)
            throw new Error('The parameter "moduleSofaReferenceId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{moduleSofaReferenceId}', encodeURIComponent('' + moduleSofaReferenceId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    getModuleSofaItem(basketId: string, moduleSofaReferenceId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfModuleSofaConfigurationProductItem> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/module-sofa/{moduleSofaReferenceId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (moduleSofaReferenceId === undefined || moduleSofaReferenceId === null)
            throw new Error('The parameter "moduleSofaReferenceId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{moduleSofaReferenceId}', encodeURIComponent('' + moduleSofaReferenceId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfModuleSofaConfigurationProductItem>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/module-sofa/{moduleSofaReferenceId}-' + cancellationContextKey : undefined);
    }
    addOrUpdateModuleConfiguration(basketId: string, moduleConfigurationId: string, request: AddOrUpdateModuleConfigurationRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/module-configuration/{moduleConfigurationId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (moduleConfigurationId === undefined || moduleConfigurationId === null)
            throw new Error('The parameter "moduleConfigurationId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{moduleConfigurationId}', encodeURIComponent('' + moduleConfigurationId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    updateItemQuantity(basketId: string, itemId: number, request: UpdateItemQuantityRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    deleteItem(basketId: string, itemId: number, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    yesterdaysCampaign(basketId: string, request: YesterdaysCampaignPriceRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/yesterdays-campaign';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    redeemPromoCode(basketId: string, request: AddPromoCodeRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/redeem-promo-code';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    removePromoCode(basketId: string, promoCode: string, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/promo-code/{promoCode}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (promoCode === undefined || promoCode === null)
            throw new Error('The parameter "promoCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{promoCode}', encodeURIComponent('' + promoCode));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    addReturnItem(basketId: string, request: AddReturnItemRequest[], messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/return-item';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addStoreDiscountToBasket(basketId: string, request: AddStoreDiscountToBasketRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/store-discount';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    soldToEmployee(basketId: string, request: SetSoldToEmployeeRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/employee-discount';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    removeSoldToEmployee(basketId: string, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/employee-discount';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    addStoreDiscountToItem(basketId: string, itemId: number, request: AddStoreDiscountToLineItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/store-discount/{itemId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    removeStoreDiscountsAndPreviousCampaignsFromBasket(basketId: string, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/store-discounts--previous-campaign';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    changeToClickAndCollect(basketId: string, request: ChangeToClickAndCollectRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/change-to-click-and-collect';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    changeClickAndCollectStore(basketId: string, storeId: string, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/change-click-and-collect-store/{storeId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (storeId === undefined || storeId === null)
            throw new Error('The parameter "storeId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{storeId}', encodeURIComponent('' + storeId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    changeToPickAndPack(basketId: string, request: ChangeToPickAndRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/change-to-pick-and-pck';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    getUpSellProducts(basketId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfListOfUpSellProductItemRelation> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/up-sell';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfListOfUpSellProductItemRelation>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/up-sell-' + cancellationContextKey : undefined);
    }
    getUpsellForInstantProducts(basketId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfProductSpotModelOf> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/up-sell/instant';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfProductSpotModelOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/up-sell/instant-' + cancellationContextKey : undefined);
    }
    replaceItem(basketId: string, request: ReplaceItemRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/replace';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    addGiftPackingToItem(basketId: string, itemId: number, request: AddGiftPackagingRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/{itemId}/gift-packaging';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    removeGiftPackingFromItem(basketId: string, itemId: number, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/{itemId}/gift-packaging';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (itemId === undefined || itemId === null)
            throw new Error('The parameter "itemId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{itemId}', encodeURIComponent('' + itemId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.delete<ClientResponseOfBasketModel>(apiUrl, messageId);
    }
    getBasketInvoiceAddress(basketId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfBasketInvoiceAddress> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/invoice-address';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfBasketInvoiceAddress>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/invoice-address-' + cancellationContextKey : undefined);
    }
    createCustomerOffer(basketId: string, request: CreateCustomerOfferRequest, messageId?: string): Promise<ClientResponseOfCustomerOfferModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/customer-offer';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfCustomerOfferModel>(apiUrl, request, messageId);
    }
    updateCustomerOffer(basketId: string, request: UpdateCustomerOfferRequest, messageId?: string): Promise<ClientResponseOfCustomerOfferModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/customer-offer';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfCustomerOfferModel>(apiUrl, request, messageId);
    }
    addCustomerOfferToBasket(basketId: string, request: AddCustomerOfferToBasketRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/customer-offer/add-to-basket';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    getEarliestDeliverDateForBasket(basketId: string, postalCode: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfEarliestCustomerDeliveryDateAndFreightPriceForBasketResult> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/delivery/earliest-delivery-date/{postalCode}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (postalCode === undefined || postalCode === null)
            throw new Error('The parameter "postalCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{postalCode}', encodeURIComponent('' + postalCode));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfEarliestCustomerDeliveryDateAndFreightPriceForBasketResult>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/delivery/earliest-delivery-date/{postalCode}-' + cancellationContextKey : undefined);
    }
    getEarliestDeliveryDateForCustomerDelivery(basketId: string, deliveryId: number, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfEarliestCustomerDeliveryDates> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/delivery/{deliveryId}/earliest-delivery-date';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfEarliestCustomerDeliveryDates>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/delivery/{deliveryId}/earliest-delivery-date-' + cancellationContextKey : undefined);
    }
    getDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery(basketId: string, deliveryId: number, itemIds: number[], messageId?: string): Promise<ClientResponseOfDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/delivery/{deliveryId}/split/earliest-delivery-date';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery>(apiUrl, itemIds, messageId);
    }
    getDeliveryTimesForCustomerDelivery(basketId: string, deliveryId: number, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfDeliveryTimesForCustomerDelivery> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/delivery/{deliveryId}/delivery-times/shipping';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfDeliveryTimesForCustomerDelivery>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/delivery/{deliveryId}/delivery-times/shipping-' + cancellationContextKey : undefined);
    }
    getPickUpPointsForDelivery(basketId: string, deliveryId: number, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfPickUpPointsForDelivery> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/delivery/{deliveryId}/pickup-points';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPickUpPointsForDelivery>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/delivery/{deliveryId}/pickup-points-' + cancellationContextKey : undefined);
    }
    getPickUpTimesForCustomerDelivery(basketId: string, deliveryId: number, hubId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfPickUpTimesForCustomerDelivery> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/delivery/{deliveryId}/delivery-times/pickup/{hubId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (deliveryId === undefined || deliveryId === null)
            throw new Error('The parameter "deliveryId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{deliveryId}', encodeURIComponent('' + deliveryId));
        if (hubId === undefined || hubId === null)
            throw new Error('The parameter "hubId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{hubId}', encodeURIComponent('' + hubId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPickUpTimesForCustomerDelivery>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/delivery/{deliveryId}/delivery-times/pickup/{hubId}-' + cancellationContextKey : undefined);
    }
    getEarliestHubPickUpDateForBasket(basketId: string, hubId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfEarliestHubPickUpdateDateForBasketResult> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/delivery/earliest-pickup-date/{hubId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        if (hubId === undefined || hubId === null)
            throw new Error('The parameter "hubId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{hubId}', encodeURIComponent('' + hubId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfEarliestHubPickUpdateDateForBasketResult>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/delivery/earliest-pickup-date/{hubId}-' + cancellationContextKey : undefined);
    }
    getDeliveryOptions(countryCode: string, basketId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfDeliveryOptionModelOf> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/delivery/delivery-options/{countryCode}';
        if (countryCode === undefined || countryCode === null)
            throw new Error('The parameter "countryCode" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{countryCode}', encodeURIComponent('' + countryCode));
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfDeliveryOptionModelOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/delivery/delivery-options/{countryCode}-' + cancellationContextKey : undefined);
    }
    getDeliveryOptionsForClickAndCollect(basketId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfDeliveryOptionModelOf> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/delivery/delivery-options/click-and-collect';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfDeliveryOptionModelOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/basket/{basketId}/delivery/delivery-options/click-and-collect-' + cancellationContextKey : undefined);
    }
    getClickAndCollectStoreInventoryStatus(basketId: string, itemIds: number[], messageId?: string): Promise<ClientResponseOfClickAndCollectStoreInventoryResultOf> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/inventory/click-and-collect-store-inventory';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfClickAndCollectStoreInventoryResultOf>(apiUrl, itemIds, messageId);
    }
    getPickAndPackInventoryStatus(basketId: string, itemIds: number[], messageId?: string): Promise<ClientResponseOfPickAndPackInventoryResultOf> {
        let apiPathAndParams = '/api/store-context/basket/{basketId}/inventory/pick-and-pack-inventory';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfPickAndPackInventoryResultOf>(apiUrl, itemIds, messageId);
    }
    getEmployees(cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfEmployeeModelOf> {
        let apiPathAndParams = '/api/store-context/employee';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfEmployeeModelOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/employee-' + cancellationContextKey : undefined);
    }
    getEmployeesByStore(storeId: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfEmployeeModelOf> {
        let apiPathAndParams = '/api/store-context/employee/store/{storeId}';
        if (storeId === undefined || storeId === null)
            throw new Error('The parameter "storeId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{storeId}', encodeURIComponent('' + storeId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfEmployeeModelOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/employee/store/{storeId}-' + cancellationContextKey : undefined);
    }
    getPrintersByStore(cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfPrinterModelOf> {
        let apiPathAndParams = '/api/store-context/printer/by-store';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfPrinterModelOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/printer/by-store-' + cancellationContextKey : undefined);
    }
    getReturnableItemBySku(sku: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfReturnableItem> {
        let apiPathAndParams = '/api/store-context/returnable-item/sku/{sku}';
        if (sku === undefined || sku === null)
            throw new Error('The parameter "sku" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{sku}', encodeURIComponent('' + sku));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfReturnableItem>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/returnable-item/sku/{sku}-' + cancellationContextKey : undefined);
    }
    getReturnableItemsByOrderNumber(orderNumber: string, cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfReturnableItemsModel> {
        let apiPathAndParams = '/api/store-context/returnable-item/ordernumber/{orderNumber}';
        if (orderNumber === undefined || orderNumber === null)
            throw new Error('The parameter "orderNumber" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{orderNumber}', encodeURIComponent('' + orderNumber));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfReturnableItemsModel>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/returnable-item/ordernumber/{orderNumber}-' + cancellationContextKey : undefined);
    }
    saveBasket(basketId: string, request: SaveBasketRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/saved-basket/{basketId}';
        if (basketId === undefined || basketId === null)
            throw new Error('The parameter "basketId" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{basketId}', encodeURIComponent('' + basketId));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.post<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    getSavedBaskets(cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfSavedBasketOf> {
        let apiPathAndParams = '/api/store-context/saved-basket';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfSavedBasketOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/saved-basket-' + cancellationContextKey : undefined);
    }
    restoreSavedBasket(savedBasketIdentifierToRestore: number, request: RestoreSavedBasketRequest, messageId?: string): Promise<ClientResponseOfBasketModel> {
        let apiPathAndParams = '/api/store-context/saved-basket/{savedBasketIdentifierToRestore}/restore';
        if (savedBasketIdentifierToRestore === undefined || savedBasketIdentifierToRestore === null)
            throw new Error('The parameter "savedBasketIdentifierToRestore" must be defined.');
        apiPathAndParams = apiPathAndParams.replace('{savedBasketIdentifierToRestore}', encodeURIComponent('' + savedBasketIdentifierToRestore));
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.put<ClientResponseOfBasketModel>(apiUrl, request, messageId);
    }
    getStoreDiscounts(cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfStoreDiscountOf> {
        let apiPathAndParams = '/api/store-context/store-discount';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfStoreDiscountOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/store-discount-' + cancellationContextKey : undefined);
    }
    getTermsAndConditions(cancellationContextKey?: string, messageId?: string): Promise<ClientResponseOfTermOf> {
        let apiPathAndParams = '/api/store-context/terms';
        apiPathAndParams = apiPathAndParams.replace(/[?&]$/, '');
        const apiUrl = serverContextStore.apiEndPoint + apiPathAndParams;
        
        return httpService.get<ClientResponseOfTermOf>(apiUrl, {}, { messagesId: messageId }, cancellationContextKey ? 'api/store-context/terms-' + cancellationContextKey : undefined);
    }
}

export const STOREClientService = new STOREClient();

export interface ClientResponseOfOrderReceiptModel {
    model: OrderReceiptModel | undefined;
    messages: ClientMessage[];
}

export interface OrderReceiptModel {
    orderNumber: string;
    orderDate: string;
    invoiceAddress: OrderReceiptInvoiceAddress | undefined;
    deliverables: OrderReceiptDeliverable[];
    summary: OrderReceiptModelSummary;
}

export interface OrderReceiptInvoiceAddress {
    buyer: BasketBuyer | undefined;
    address: BasketAddress | undefined;
    buyerContactInformation: BasketBuyerContactInformation | undefined;
}

export interface BasketBuyer {
    firstName: string;
    lastName: string;
    vatNumber: string | undefined;
    companyName: string | undefined;
}

export interface BasketAddress {
    street: string;
    street2: string | undefined;
    postalCode: string;
    unknownPostalCode: boolean;
    city: string;
    countryCode: string;
    country: string;
    otherCountryName: string | undefined;
    hasLift: boolean;
}

export interface BasketBuyerContactInformation {
    emailAddress: string;
    phoneNumber: string | undefined;
    alternateNumber: string | undefined;
}

export interface OrderReceiptDeliverable {
    type: OrderReceiptDeliverableType;
    deliveryDate: string | undefined;
    deliveryOptions: string[];
    deliveryType: OrderDeliveryType | undefined;
    deliveryAddress: OrderReceiptDeliveryAddress | undefined;
    items: OrderReceiptBaseItemModel[];
    discriminator: string;
}

export enum OrderReceiptDeliverableType {
    CustomerDelivery = 0,
    PickUp = 1,
    PickAndPack = 2,
    ClickAndCollect = 3,
    Instant = 4,
    Return = 5,
    GiftCertificate = 6,
}

export enum OrderDeliveryType {
    Shipping = 1,
    PickUp = 2,
    Manual = 99,
}

export interface OrderReceiptDeliveryAddress {
    locationName: string | undefined;
    buyer: BasketBuyer | undefined;
    address: BasketAddress;
}

export interface OrderReceiptBaseItemModel {
    id: number;
    name: string;
    quantity: number;
    quantityMultiplier: number;
    price: OrderReceiptItemPrice;
    discriminator: string;
}

export interface OrderReceiptItemPrice {
    listPrice: BoliaMoney | undefined;
    listPriceTotal: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    discounts: OrderReceiptDiscount[];
    salesPriceTotal: BoliaMoney | undefined;
}

export interface BoliaMoney {
    rawAmount: number;
    amount: string;
    currency: string;
}

export interface OrderReceiptDiscount {
    type: OrderReceiptDiscountType;
    percentage: number | undefined;
    discount: BoliaMoney;
    discountTotal: BoliaMoney;
}

export enum OrderReceiptDiscountType {
    Campaign = 2,
    PromoCode = 3,
    Store = 4,
    SoldToEmployee = 5,
    Outlet = 6,
    PreviousCampaign = 7,
    MyBoliaBoost = 8,
}

export interface OrderReceiptItemModel extends OrderReceiptBaseItemModel {
    sku: string;
    imageVersion: number;
    specifications: SpecificationAttribute[];
    hasGiftPacking: boolean;
    discriminator: string;
}

export interface SpecificationAttribute {
    name: string;
    label: string;
    value: string;
}

export interface OrderReceiptOutletItemModel extends OrderReceiptItemModel {
    damageDescriptions: string[] | undefined;
}

export interface OrderReceiptModuleSofaItemModel extends OrderReceiptBaseItemModel {
    modules: OrderReceiptItemModel[];
    image: string;
}

export interface OrderReceiptModuleConfigurationItemModel extends OrderReceiptBaseItemModel {
    modules: OrderReceiptItemModel[];
    image: string;
}

export interface PickAndPackOrderReceiptDeliverable extends OrderReceiptDeliverable {
    parcelShop: OrderReceiptParcelShopModel;
}

export interface OrderReceiptParcelShopModel {
    companyName: string;
    street: string;
    street2: string | undefined;
    postalCode: string;
    city: string;
    countryCode: string;
    phoneNumber: string;
}

export interface OrderReceiptModelSummary {
    salesPriceSubTotal: BoliaMoney;
    discountTotal: BoliaMoney | undefined;
    freightPriceTotal: BoliaMoney | undefined;
    serviceOptions: OrderReceiptServiceOption[];
    deliveryOptions: OrderDeliveryOptionModel[];
    giftCards: OrderReceiptSummaryGiftCard[] | undefined;
    salesPriceTotal: BoliaMoney;
    salesTax: BoliaMoney;
    ecoTaxTotal: BoliaMoney | undefined;
}

export interface OrderReceiptServiceOption {
    name: string;
    quantity: number;
    sku: string;
    description: string | undefined;
    price: BoliaMoney;
}

export interface OrderDeliveryOptionModel {
    itemId: string;
    name: string;
    description: string | undefined;
    price: BoliaMoney;
}

export interface OrderReceiptSummaryGiftCard {
    giftCertificateNumber: string;
    amountSpent: BoliaMoney;
    amountRemaining: BoliaMoney;
}

export interface ClientMessage {
    labelKey: string | undefined;
    message: string;
    messageType: ClientMessageType;
}

export enum ClientMessageType {
    Error = 0,
    Warning = 1,
    Info = 2,
}

export interface ClientResponse {
    messages: ClientMessage[];
}

export interface PrintOrderReceiptByOrderNumberRequest {
    orderNumber: string;
    printerId: number;
}

export interface ClientResponseOfPrintGiftCertificatesResult {
    model: PrintGiftCertificatesResult | undefined;
    messages: ClientMessage[];
}

export interface PrintGiftCertificatesResult {
    labels: LabelWithNamedArguments[];
}

export interface LabelWithNamedArguments {
    label: string;
    severity: LabelSeverity;
    namedParams: { [key: string]: any; };
}

export enum LabelSeverity {
    Error = 0,
    Warning = 1,
    Information = 2,
}

export interface PrintGiftCertificatesByOrderNumberRequest {
    orderNumber: string;
    printerId: number;
}

export interface ClientResponseOfCustomerAddressSuggestionModelOf {
    model: CustomerAddressSuggestionModel[] | undefined;
    messages: ClientMessage[];
}

export interface CustomerAddressSuggestionModel {
    displayName: string;
    address: CustomerAddressModel;
    phoneNumber: string | undefined;
    alternativePhoneNumber: string | undefined;
    email: string | undefined;
    isMyBoliaUser: boolean;
    accountId: string | undefined;
}

export interface CustomerAddressModel {
    firstName: string | undefined;
    lastName: string | undefined;
    street: string | undefined;
    extraInformation: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
}

export interface ClientResponseOfCustomerAddressSuggestionModel {
    model: CustomerAddressSuggestionModel | undefined;
    messages: ClientMessage[];
}

export interface PrintCustomerOfferByIdRequest {
    customerOfferId: string;
    printerId: number;
}

export interface ClientResponseOfCreateConsentResponse {
    model: CreateConsentResponse | undefined;
    messages: ClientMessage[];
}

export interface CreateConsentResponse {
    qrCodeContent: any | undefined;
    consentPageUrl: string;
}

export interface CreateCustomerOfferConsentRequest {
    targetPageUrl: string;
    basketId: string;
    emailAddress: string;
    imageSizeInPixels: number | undefined;
}

export interface AcceptCustomerOfferConsentRequest {
    consentRequestId: string;
}

export interface ClientResponseOfBoliaMoney {
    model: BoliaMoney | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfBasketCheckoutModel {
    model: BasketCheckoutModel | undefined;
    messages: ClientMessage[];
}

export interface BasketCheckoutModel {
    basketId: string;
    invoiceAddressValidationRule: InvoiceAddressValidationRule;
    invoiceAddress: BasketInvoiceAddress | undefined;
    items: BaseProductItem[];
    summary: BasketCheckoutModelSummary;
    paymentOptions: PaymentOption[];
    termsId: number;
    soldByEmployeeId: string;
    hasMyBoliaBoostCampaignDiscount: boolean;
    deliverables: CheckOutDeliverable[];
}

export enum InvoiceAddressValidationRule {
    AllRequired = 0,
    NameAndEmailRequired = 1,
    NothingRequired = 2,
}

export interface BasketInvoiceAddress {
    buyer: BasketBuyer | undefined;
    address: BasketAddress | undefined;
    buyerContactInformation: BasketBuyerContactInformation | undefined;
    customerInformation: BasketCustomerInformation | undefined;
    signUpNewsLetter: boolean;
    signUpMyBolia: boolean;
}

export interface BasketCustomerInformation {
    accountId: string;
    isMyBoliaUser: boolean;
}

export interface BaseItem {
    id: number;
    created: Date;
    lastModified: Date;
    uniqueIdentifier: string;
    primaryItemMessages: ItemMessage[];
    secondaryItemMessages: ItemMessage[];
    type: ItemType;
    discriminator: string;
}

export interface BaseProductItem extends BaseItem {
    sku: string;
    name: string;
    quantity: number;
    quantityMultiplier: number;
    isDiscontinued: boolean;
    isSoldOut: boolean;
    imageVersion: number;
    price: ProductItemPrice | undefined;
    specifications: SpecificationAttribute[] | undefined;
    clickAndCollectEnabled: boolean;
    pickAndPackEnabled: boolean;
    giftPackingOption: GiftPackingItemOption | undefined;
    discriminator: string;
}

export interface ProductItemPrice {
    listPrice: BoliaMoney | undefined;
    listPriceTotal: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    discounts: BaseDiscount[] | undefined;
}

export interface BaseDiscount {
    type: DiscountType;
    percentage: number;
    discount: BoliaMoney;
    discountTotal: BoliaMoney;
    discriminator: string;
}

export enum DiscountType {
    Country = 1,
    Campaign = 2,
    PromoCode = 3,
    Store = 4,
    SoldToEmployee = 5,
    Outlet = 6,
    PreviousCampaign = 7,
    MyBoliaBoost = 8,
}

export interface CampaignDiscount extends BaseDiscount {
    offerId: string;
    offerName: string;
    yesterdaysCampaign: boolean;
}

export interface OutletDiscount extends BaseDiscount {
}

export interface EmployeeDiscount extends BaseDiscount {
}

export interface StoreDiscountModel extends BaseDiscount {
    givenBy: string;
}

export interface PromoCodeDiscount extends BaseDiscount {
    redeemCode: string;
}

export interface MyBoliaBoostDiscountModel extends BaseDiscount {
    offerId: string;
    offerName: string;
}

export interface GiftPackingItemOption {
    price: BoliaMoney;
    totalPrice: BoliaMoney;
    quantity: number;
    description: string;
}

export interface ItemMessage extends LabelWithNamedArguments {
    type: ItemMessageType;
}

export enum ItemMessageType {
    Default = 0,
    Basket = 1,
    CheckOut = 2,
}

export enum ItemType {
    Regular = 1,
    Instant = 2,
    Custom = 3,
    GiftCertificate = 4,
    Outlet = 5,
    InstantOutlet = 6,
    ClickAndCollect = 7,
    PickAndPack = 8,
    ModuleSofa = 9,
    Return = 10,
    CarrierBag = 11,
    ModuleSofaItem = 12,
    ModuleConfiguration = 13,
    ModuleConfigurationItem = 14,
}

export interface ReturnItem extends BaseProductItem {
    maxReturnQuantity: number;
}

export interface RegularProductItem extends BaseProductItem {
}

export interface PickAndPackProductItem extends BaseProductItem {
    inventoryStatus: InventoryStatus | undefined;
    giftPackingMessage: GiftPackingMessage | undefined;
}

export interface InventoryStatus {
    totalAvailable: number;
    reservedByUser: number;
}

export interface GiftPackingMessage {
    from: string | undefined;
    to: string | undefined;
    message: string[] | undefined;
}

export interface ClickAndCollectProductItem extends BaseProductItem {
    inventoryStatus: InventoryStatus | undefined;
}

export interface InstantProductItem extends BaseProductItem {
}

export interface InstantOutletProductItem extends BaseProductItem {
    inventSerialId: string | undefined;
    damageDescriptions: string[] | undefined;
    canBeDelivered: boolean;
    isConsignment: boolean;
}

export interface OutletProductItem extends BaseProductItem {
    inventSerialId: string | undefined;
    damageDescriptions: string[] | undefined;
    recId: number | undefined;
    canBeDelivered: boolean;
    hub: string | undefined;
    isConsignment: boolean;
}

export interface CarrierBagProductItem extends BaseProductItem {
}

export interface CustomProductItem extends BaseProductItem {
}

export interface ModuleSofaConfigurationProductItem extends BaseProductItem {
    modules: ModuleSofaProductItem[];
    modulesConnections: ModuleSofaItem[];
    specification: ModuleSofaSpecification | undefined;
    image: string | undefined;
    moduleReferenceId: string | undefined;
}

export interface ModuleSofaProductItem extends BaseProductItem {
}

export interface ModuleSofaItem {
    sku: string;
    connections: ModuleSofaConnection;
}

export interface ModuleSofaConnection {
    a: string;
    b: string;
    c: string;
    d: string;
}

export interface ModuleSofaSpecification {
    name: string;
    image: string;
    width: number;
    height: number;
}

export interface GiftCardProductItem extends BaseProductItem {
}

export interface ModuleConfigurationProductItem extends BaseProductItem {
    modules: ModuleProductItem[];
    image: string | undefined;
    moduleReferenceId: string | undefined;
    moduleConfigurationSpecification: ModuleConfigurationSpecification | undefined;
}

export interface ModuleProductItem extends BaseProductItem {
}

export interface ModuleConfigurationSpecification {
    depth: number;
    height: number;
    width: number;
}

export interface BasketCheckoutModelSummary {
    listPriceTotal: BoliaMoney | undefined;
    discountTotal: BoliaMoney | undefined;
    salesPriceSubTotal: BoliaMoney | undefined;
    freightPriceTotal: BoliaMoney | undefined;
    salesTax: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    deliveryOptions: DeliveryOptionModel[] | undefined;
    serviceItemsTotals: ServiceOptionModel[];
}

export interface DeliveryOptionModel {
    name: string;
    sku: string;
    description: string | undefined;
    price: BoliaMoney;
}

export interface ServiceOptionModel {
    name: string;
    quantity: number;
    sku: string;
    description: string | undefined;
    Price: BoliaMoney;
}

export interface PaymentOption {
    addressValidationRule: InvoiceAddressValidationRule;
    paymentOptionType: PaymentOptionType;
    enabled: boolean;
    discriminator: string;
}

export enum PaymentOptionType {
    Pos = 0,
    Online = 1,
    BankTransfer = 2,
}

export interface OnlinePaymentOption extends PaymentOption {
    partialPaymentPercentage: number | undefined;
    paymentOptionTypes: OnlinePaymentOptionType[];
}

export interface OnlinePaymentOptionType {
    paymentType: OnlinePaymentType;
    description: LabelWithNamedArguments;
}

export enum OnlinePaymentType {
    OnlinePaymentFull = 0,
    OnlinePaymentPartial = 1,
}

export interface BankTransferPaymentOption extends PaymentOption {
    paymentOptionTypes: BankTransferPaymentOptionType[];
}

export interface BankTransferPaymentOptionType {
    amount: BoliaMoney;
}

export interface PosPaymentOption extends PaymentOption {
    isPosV2Payment: boolean;
}

export interface CheckOutDeliverable {
    id: number;
    type: BasketDeliverableType;
    itemIds: number[];
    isValid: boolean;
    discriminator: string;
}

export enum BasketDeliverableType {
    CustomerDelivery = 0,
    PickUp = 1,
    PickAndPack = 2,
    ClickAndCollect = 3,
    Instant = 4,
    Return = 5,
}

export interface CheckOutDeliverableWithAddress extends CheckOutDeliverable {
    deliveryAddress: BasketDeliveryAddress | undefined;
}

export interface BasketDeliveryAddress {
    buyer: BasketBuyer | undefined;
    address: BasketAddress | undefined;
}

export interface CustomerDeliveryCheckOutDeliverable extends CheckOutDeliverableWithAddress {
    deliveryType: DeliveryType | undefined;
    deliveryTimeId: number | undefined;
    selectedPickupPoint: string | undefined;
    freight: FreightModel | undefined;
    deliveryOptions: string[];
    generalTermsAndConditions: string | undefined;
    isPickupDisabled: boolean;
    comment: string | undefined;
}

export enum DeliveryType {
    Shipping = 1,
    PickUp = 2,
    Manual = 99,
}

export interface FreightModel {
    price: BoliaMoney | undefined;
    errorGettingPrice: boolean;
}

export interface PickUpCheckOutDeliverable extends CheckOutDeliverable {
    deliveryType: DeliveryType | undefined;
    deliveryTimeId: number | undefined;
    freight: FreightModel | undefined;
}

export interface ClickAndCollectCheckOutDeliverable extends CheckOutDeliverable {
    text: LabelWithNamedArguments;
    storeId: string | undefined;
    deliveryOptions: string[];
}

export interface PickAndPackCheckOutDeliverable extends CheckOutDeliverable {
    text: LabelWithNamedArguments;
    options: PickAndPackCheckOutDeliveryOption[];
}

export interface PickAndPackCheckOutDeliveryOption {
    sku: string;
    deliveryType: PickAndPackDeliveryType;
    price: BoliaMoney;
    isSelected: boolean;
    discriminator: string;
}

export enum PickAndPackDeliveryType {
    ParcelShop = 0,
    HomeDelivery = 1,
}

export interface PickAndPackParcelShopCheckOutDeliveryOption extends PickAndPackCheckOutDeliveryOption {
    parcelShop: ParcelShopModel | undefined;
}

export interface ParcelShopModel {
    idNumber: string;
    companyName: string;
    street: string;
    street2: string;
    postalCode: string;
    city: string;
    countryCode: string;
    telephone: string;
    longitude: string | undefined;
    latitude: string | undefined;
    metersToShop: number | undefined;
    openingHours: OpeningHour[] | undefined;
}

export interface OpeningHour {
    dayOfWeek: string | undefined;
    openFrom: string | undefined;
    openTo: string | undefined;
    breaks: Break[] | undefined;
}

export interface Break {
    from: string | undefined;
    to: string | undefined;
}

export interface PickAndPackHomeDeliveryCheckOutDeliveryOption extends PickAndPackCheckOutDeliveryOption {
    deliveryAddress: BasketDeliveryAddress | undefined;
}

export interface AddInvoiceAddressToBasketRequest {
    validationRule: InvoiceAddressValidationRule;
    invoiceAddress: BasketInvoiceAddress;
}

export interface SetDeliveryTimeRequest {
    deliveryType: DeliveryType;
    requestedDeliveryType: DeliveryType | undefined;
    postalCode: string;
    inventoryLocationId: string | undefined;
    deliveryTime: DeliveryTime | undefined;
}

export interface DeliveryTime {
    deliveryTimeId: number;
    deliveryDate: Date;
    startTime: Date;
    endTime: Date;
    modeOfDelivery: string;
}

export interface SetCustomerDeliveryCommentRequest {
    comment: string | undefined;
}

export interface ClientResponseOfCheckOutPosPaymentResult {
    model: CheckOutPosPaymentResult | undefined;
    messages: ClientMessage[];
}

export interface CheckOutPaymentResult {
    itemsOutOfStock: number[] | undefined;
    redirectUrl: string | undefined;
    isCheckoutAble: boolean;
}

export interface CheckOutPosPaymentResult extends CheckOutPaymentResult {
    posIntegrationExtensionId: string | undefined;
    isPos2Enabled: boolean;
}

export interface CheckOutPosRequest {
    soldByEmployee: EmployeeModel;
}

export interface EmployeeModel {
    id: string;
    name: string;
}

export interface ClientResponseOfCheckOutPaymentResult {
    model: CheckOutPaymentResult | undefined;
    messages: ClientMessage[];
}

export interface CheckOutOnlinePaymentRequest {
    soldByEmployee: EmployeeModel;
    onlinePaymentType: OnlinePaymentType;
}

export interface ClientResponseOfParcelShopModelOf {
    model: ParcelShopModel[] | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfFinalizeBankTransferPaymentResult {
    model: FinalizeBankTransferPaymentResult | undefined;
    messages: ClientMessage[];
}

export interface FinalizeBankTransferPaymentResult {
    itemsOutOfStock: number[] | undefined;
    orderNumber: string | undefined;
    receiptLink: string | undefined;
}

export interface CheckOutBankTransferPaymentRequest {
    soldByEmployee: EmployeeModel;
}

export interface ClientResponseOfBasketModel {
    model: BasketModel | undefined;
    messages: ClientMessage[];
}

export interface BasketModel {
    basketId: string;
    storeId: string;
    retailChannelId: string;
    clickAndCollectStoreId: string | undefined;
    numberOfItems: number;
    deliverables: Deliverable[];
    summary: BasketModelSummary;
    isCheckoutAble: boolean;
    created: Date;
    lastModified: Date;
    soldToEmployeeId: string | undefined;
    customerOfferId: string | undefined;
    upSellItemCounter: number;
    hasMyBoliaBoostCampaignDiscount: boolean;
    hasStoreDiscountOrYesterdaysCampaignApplied: boolean;
    canCreateCustomerOffer: boolean;
    currentEmployeeId: string | undefined;
}

export interface Deliverable {
    type: DeliverableType;
    items: BaseItem[];
    discriminator: string;
}

export enum DeliverableType {
    CustomerDelivery = 0,
    PickUp = 1,
    PickAndPack = 2,
    ClickAndCollect = 3,
    Instant = 4,
    Return = 5,
}

export interface DeliverableForPickAndPack extends Deliverable {
    changeToClickAndCollectEnabled: boolean;
    text: LabelWithNamedArguments;
}

export interface DeliverableForClickAndCollect extends Deliverable {
    storeId: string;
    changeToPickAndPackEnabled: boolean;
    text: LabelWithNamedArguments;
}

export interface DeliverableForPickUp extends Deliverable {
    hubId: string | undefined;
}

export interface BasketModelSummary {
    listPriceTotal: BoliaMoney | undefined;
    discountTotal: BoliaMoney | undefined;
    salesPriceSubTotal: BoliaMoney | undefined;
    freightPriceTotal: BoliaMoney | undefined;
    salesTax: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    appliedPromoCodes: PromoCodeModel[];
    serviceItemsTotals: ServiceOptionModel[];
    buyAndGetYPctDiscount: BuyAndGetYPctDiscountModel | undefined;
}

export interface PromoCodeModel {
    redeemCode: string;
    isActive: boolean;
}

export interface BuyAndGetYPctDiscountModel {
    label: LabelWithNamedArguments;
}

export interface AddBasketItemRequest {
    sku: string;
    quantity: number;
    relatedItemId: number | undefined;
}

export interface AddClickAndCollectBasketItemRequest {
    sku: string;
    quantity: number;
    clickAndCollectStoreId: string;
    relatedItemId: number | undefined;
}

export interface AddInstantItemRequest {
    itemId: string;
    quantity: number;
}

export interface AddOutletItemRequest {
    recId: number;
}

export interface AddCustomItemRequest {
    name: string;
    price: number;
}

export interface AddGiftCardItemRequest {
    amount: number;
}

export interface AddModuleSofaRequest {
    specification: ModuleSofaSpecification;
    modules: ModuleSofaItem[];
}

export interface ClientResponseOfModuleSofaConfigurationProductItem {
    model: ModuleSofaConfigurationProductItem | undefined;
    messages: ClientMessage[];
}

export interface AddOrUpdateModuleConfigurationRequest {
    configuration: ModuleConfiguration;
    modules: ModuleConfigurationItem[];
}

export interface ModuleConfiguration {
    name: string;
    depth: number;
    height: number;
    width: number;
    image: string;
}

export interface ModuleConfigurationItem {
    sku: string;
    quantity: number;
}

export interface UpdateItemQuantityRequest {
    quantity: number;
    delta: boolean;
}

export interface YesterdaysCampaignPriceRequest {
    lineItemId: number | undefined;
    enable: boolean;
}

export interface AddPromoCodeRequest {
    redeemCode: string;
}

export interface AddReturnItemRequest {
    sku: string;
    quantity: number;
    price: number;
    salesInformation: ReturnItemSalesInformation | undefined;
}

export interface ReturnItemSalesInformation {
    salesLineId: number;
    salesOrderNumber: string;
    sku: string;
    lineDescription: string;
    commissionSalesRepresentativeGroupId: string;
    inventoryLotId: string;
    isOutletProduct: boolean;
    maxReturnQuantity: number;
}

export interface AddStoreDiscountToBasketRequest {
    id: string;
    name: string;
    percentage: number;
    isFixed: boolean;
}

export interface SetSoldToEmployeeRequest {
    employeeId: string;
}

export interface AddStoreDiscountToLineItemRequest {
    id: string;
    name: string;
    percentage: number;
    isFixed: boolean;
}

export interface ChangeToClickAndCollectRequest {
    clickAndCollectStoreId: string;
    itemIds: number[];
}

export interface ChangeToPickAndRequest {
    itemIds: number[];
}

export interface ClientResponseOfListOfUpSellProductItemRelation {
    model: UpSellProductItemRelation[] | undefined;
    messages: ClientMessage[];
}

export interface UpSellProductItemRelation {
    items: UpSellItemInBasket[];
    sku: string | undefined;
}

export interface UpSellItemInBasket {
    itemId: number;
    isInBasket: boolean;
}

export interface ClientResponseOfProductSpotModelOf {
    model: ProductSpotModel[] | undefined;
    messages: ClientMessage[];
}

export interface ProductSpotModel {
    id: number;
    sku: string;
    name: string;
    price: ProductPriceModel;
    imageProperties: ImageProperties | undefined;
    quantityMultiplier: number;
    lightingSpecification: LightingSpecification | undefined;
    certificates: Certificate[] | undefined;
    isPickAndPack: boolean;
    description: string | undefined;
    labels: ProductLabel[] | undefined;
    designerName: string | undefined;
    familyName: string | undefined;
    ean: string | undefined;
    metaData: ProductMetaData;
    fromPrice: BoliaMoney | undefined;
    purchaseOptions: PurchaseOption[];
}

export interface ProductPriceModel {
    listPrice: BoliaMoney;
    salesPrice: BoliaMoney;
    ecoTaxPrice: BoliaMoney | undefined;
    discount: ProductBaseDiscount | undefined;
    priceValidUntil: Date | undefined;
}

export interface ProductBaseDiscount {
    type: ProductDiscountType;
    discount: BoliaMoney;
    percentage: number;
    expiryLabel: LabelWithNamedArguments | undefined;
    discriminator: string;
}

export enum ProductDiscountType {
    Campaign = 0,
    MyBoliaBoost = 1,
}

export interface ProductCampaignDiscount extends ProductBaseDiscount {
}

export interface ProductMyBoliaBoostDiscount extends ProductBaseDiscount {
}

export interface ImageProperties {
    version: number;
    type: DefaultImageType;
}

export enum DefaultImageType {
    Default = 0,
    Angle = 1,
}

export interface LightingSpecification {
    specificationUrl: string | undefined;
    energyClassification: string | undefined;
    energyClassificationUrl: string | undefined;
}

export interface Certificate {
    name: string;
    imageUrl: string | undefined;
    code: string;
    imageVersion: number | undefined;
}

export interface ProductLabel {
    type: ProductLabelType;
    text: string | undefined;
    backgroundColorHex: string | undefined;
}

export enum ProductLabelType {
    NewArrival = 0,
    Customize = 1,
    ProductSpot = 2,
}

export interface ProductMetaData {
    family: string | undefined;
    retailHierarchy: string | undefined;
    businessArea: string | undefined;
    brand: string | undefined;
    ean: string | undefined;
}

export interface PurchaseOption {
    type: PurchaseOptionType;
    sortOrder: number;
    quantityMultiplier: number;
    discriminator: string;
}

export enum PurchaseOptionType {
    Instant = 0,
    PickAndPack = 1,
    ClickAndCollect = 2,
    Standard = 3,
    Special = 4,
    B2BStandard = 5,
    InStoreOnly = 6,
    B2BExpress = 7,
    ModuleConfiguration = 8,
}

export interface StandardPurchaseOption extends PurchaseOption {
    title: string | undefined;
    description: string | undefined;
}

export interface InstantPurchaseOption extends PurchaseOption {
    title: string;
}

export interface PickAndPackPurchaseOption extends PurchaseOption {
    backOrderAvailable: boolean;
    title: string;
    description: string | undefined;
}

export interface ClickAndCollectPurchaseOption extends PurchaseOption {
    backOrderAvailable: boolean;
    title: string;
}

export interface SpecialDeliveryPurchaseOption extends PurchaseOption {
    findStoreAndDealersTitle: string;
    specialDeliveryTitle: string;
    specialDeliveryDescription: string;
}

export interface B2BStandardPurchaseOption extends PurchaseOption {
    title: string;
}

export interface InStoreOnlyPurchaseOption extends PurchaseOption {
    title: string;
    description: string | undefined;
}

export interface B2BExpressPurchaseOption extends PurchaseOption {
    title: string;
}

export interface ModuleConfigurationPurchaseOption extends PurchaseOption {
    title: string | undefined;
}

export interface ReplaceItemRequest {
    lineItemId: string;
    targetSku: string;
}

export interface AddGiftPackagingRequest {
    from: string | undefined;
    to: string | undefined;
    message: string[] | undefined;
}

export interface ClientResponseOfBasketInvoiceAddress {
    model: BasketInvoiceAddress | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfCustomerOfferModel {
    model: CustomerOfferModel | undefined;
    messages: ClientMessage[];
}

export interface CustomerOfferModel {
    customerOfferId: string;
    invoiceAddress: BasketInvoiceAddress | undefined;
    items: BaseProductItem[];
    summary: CustomerOfferModelSummary;
}

export interface CustomerOfferModelSummary {
    listPriceTotal: BoliaMoney | undefined;
    discountTotal: BoliaMoney | undefined;
    salesPriceSubTotal: BoliaMoney | undefined;
    freightPriceTotal: BoliaMoney | undefined;
    salesTax: BoliaMoney | undefined;
    salesPriceTotal: BoliaMoney | undefined;
    ecoTaxTotal: BoliaMoney | undefined;
}

export interface CreateCustomerOfferRequest {
    basketInvoiceAddress: BasketInvoiceAddress;
    employeeId: string;
    note: string | undefined;
    message: string | undefined;
    printerId: number | undefined;
}

export interface UpdateCustomerOfferRequest {
    basketInvoiceAddress: BasketInvoiceAddress;
    employeeId: string;
    note: string | undefined;
    message: string | undefined;
    printerId: number | undefined;
}

export interface AddCustomerOfferToBasketRequest {
    customerOfferId: string;
}

export interface ClientResponseOfEarliestCustomerDeliveryDateAndFreightPriceForBasketResult {
    model: EarliestCustomerDeliveryDateAndFreightPriceForBasketResult | undefined;
    messages: ClientMessage[];
}

export interface EarliestCustomerDeliveryDateAndFreightPriceForBasketResult {
    text: LabelWithNamedArguments;
    itemMessages: CustomerDeliveryItemMessage[] | undefined;
    freightPrice: BoliaMoney | undefined;
}

export interface CustomerDeliveryItemMessage {
    itemId: number;
    itemMessage: ItemMessage;
}

export interface ClientResponseOfEarliestCustomerDeliveryDates {
    model: EarliestCustomerDeliveryDates | undefined;
    messages: ClientMessage[];
}

export interface EarliestCustomerDeliveryDates {
    labelForItems: LabelForItem[] | undefined;
    generalLabel: LabelWithNamedArguments;
    canBeSplit: boolean;
    canRemoveSplit: boolean;
    shouldBeSplit: boolean;
    canBeDelivered: boolean;
    canUndoSplit: boolean;
}

export interface LabelForItem {
    itemId: number;
    label: LabelWithNamedArguments;
}

export interface ClientResponseOfDeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery {
    model: DeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery | undefined;
    messages: ClientMessage[];
}

export interface DeliveryDateAndFreightPriceForSplitItemsInCustomerDelivery {
    text: LabelWithNamedArguments;
}

export interface ClientResponseOfDeliveryTimesForCustomerDelivery {
    model: DeliveryTimesForCustomerDelivery | undefined;
    messages: ClientMessage[];
}

export interface DeliveryTimesForCustomerDelivery {
    message: LabelWithNamedArguments | undefined;
    deliveryTimeSlotModel: DeliveryTimeSlotModel | undefined;
}

export interface DeliveryTimeSlotModel {
    deliveryType: DeliveryType;
    postalCode: string;
    inventoryLocationId: string;
    deliverySlots: DeliverySlot[] | undefined;
    requestedDeliveryType: DeliveryType | undefined;
}

export interface DeliverySlot {
    startTime: Date;
    endTime: Date;
    deliveryDate: Date;
    deliveryTimeId: number;
    modeOfDelivery: string;
    formattedDeliveryDate: string;
}

export interface ClientResponseOfPickUpPointsForDelivery {
    model: PickUpPointsForDelivery | undefined;
    messages: ClientMessage[];
}

export interface PickUpPointsForDelivery {
    defaultPickUpId: string | undefined;
    hubs: HubModel[];
}

export interface HubModel {
    id: string;
    name: string;
    street: string;
    zipCode: string;
    city: string;
    countryCode: string;
    countryName: string;
    latitude: number;
    longitude: number;
    isPickUpPoint: boolean;
}

export interface ClientResponseOfPickUpTimesForCustomerDelivery {
    model: PickUpTimesForCustomerDelivery | undefined;
    messages: ClientMessage[];
}

export interface PickUpTimesForCustomerDelivery {
    message: LabelWithNamedArguments | undefined;
    deliveryTimeSlotModel: DeliveryTimeSlotModel | undefined;
}

export interface ClientResponseOfEarliestHubPickUpdateDateForBasketResult {
    model: EarliestHubPickUpdateDateForBasketResult | undefined;
    messages: ClientMessage[];
}

export interface EarliestHubPickUpdateDateForBasketResult {
    text: LabelWithNamedArguments;
    itemMessages: PickDeliveryItemMessage[] | undefined;
}

export interface PickDeliveryItemMessage {
    itemId: number;
    itemMessage: ItemMessage;
}

export interface ClientResponseOfDeliveryOptionModelOf {
    model: DeliveryOptionModel[] | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfClickAndCollectStoreInventoryResultOf {
    model: ClickAndCollectStoreInventoryResult[] | undefined;
    messages: ClientMessage[];
}

export interface ClickAndCollectStoreInventoryResult {
    storeId: string;
    storeTitle: string;
    status: LabelWithNamedArguments;
    itemIdsAvailable: number[];
    itemIdsNotAvailable: number[];
}

export interface ClientResponseOfPickAndPackInventoryResultOf {
    model: PickAndPackInventoryResult[] | undefined;
    messages: ClientMessage[];
}

export interface PickAndPackInventoryResult {
    itemId: number;
    canBePickAndPackDelivered: boolean;
}

export interface ClientResponseOfEmployeeModelOf {
    model: EmployeeModel[] | undefined;
    messages: ClientMessage[];
}

export interface ClientResponseOfPrinterModelOf {
    model: PrinterModel[] | undefined;
    messages: ClientMessage[];
}

export interface PrinterModel {
    id: number;
    name: string;
}

export interface ClientResponseOfReturnableItem {
    model: ReturnableItem | undefined;
    messages: ClientMessage[];
}

export interface ReturnableItem {
    productName: string;
    sku: string;
    quantityMultiplier: number;
    listPrice: BoliaMoney;
    salesPrice: BoliaMoney;
    salesInformation: ReturnItemSalesInformation | undefined;
    hasDiscount: boolean;
}

export interface ClientResponseOfReturnableItemsModel {
    model: ReturnableItemsModel | undefined;
    messages: ClientMessage[];
}

export interface ReturnableItemsModel {
    orderNumber: string;
    items: ReturnableItem[];
}

export interface SaveBasketRequest {
    basketSalesTotal: number;
}

export interface ClientResponseOfSavedBasketOf {
    model: SavedBasket[] | undefined;
    messages: ClientMessage[];
}

export interface SavedBasket {
    id: number;
    created: Date;
    employeeName: string;
    basketSalesTotal: BoliaMoney;
}

export interface RestoreSavedBasketRequest {
    currentBasketId: string;
}

export interface ClientResponseOfStoreDiscountOf {
    model: StoreDiscount[] | undefined;
    messages: ClientMessage[];
}

export interface StoreDiscount {
    id: string;
    name: string;
    percentage: number | undefined;
    allowUseOnEntireBasket: boolean;
    isFixed: boolean;
}

export interface ClientResponseOfTermOf {
    model: Term[] | undefined;
    messages: ClientMessage[];
}

export interface Term {
    id: number;
    identifier: string;
    title: string;
    description: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}
